import { defineChannelContract } from 'shared/channels';
import type { AbortUploadDetail } from 'shared/domain/messages/httpQueue/eventMessages';

/** Requests to the worker's HTTP queue. */
export const httpQueueContract = defineChannelContract<{
  requests: {
    abortUpload: { request: AbortUploadDetail; response: void };
  };
  events: Record<never, never>;
}>('httpQueueChannel');
